/* =========================================================================
   SWGEAR FAQ accordion
   - Single-open-at-a-time by default (data-single-open="true")
   - Toggles aria-expanded + data-open
   - Smooth max-height transition handled by CSS
   ========================================================================= */

(function () {
  'use strict';

  function bind(container) {
    const singleOpen = container.dataset.singleOpen === 'true';
    const items = container.querySelectorAll('.swgear-faq__item');

    items.forEach((item) => {
      const btn = item.querySelector('.swgear-faq__q');
      const icon = item.querySelector('.swgear-faq__icon');
      if (!btn) return;

      btn.addEventListener('click', () => {
        const isOpen = item.dataset.open === 'true';

        if (singleOpen && !isOpen) {
          items.forEach((other) => {
            if (other !== item) {
              other.dataset.open = 'false';
              other.classList.remove('is-open');
              const otherBtn = other.querySelector('.swgear-faq__q');
              const otherIcon = other.querySelector('.swgear-faq__icon');
              if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
              if (otherIcon) otherIcon.textContent = '+';
            }
          });
        }

        item.dataset.open = isOpen ? 'false' : 'true';
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (icon) icon.textContent = isOpen ? '+' : '−';
      });
    });
  }

  function init() {
    document.querySelectorAll('.swgear-faq').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.swgear-faq').forEach(bind);
  });
})();
